var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 27,
    rx: 4,
    transform: "translate(0 -2)",
    fill: "rgba(255,255,255,0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.947,1.5H4.421A1.425,1.425,0,0,0,3,2.921v9.947H4.421V2.921h8.526Zm2.131,2.842H7.263A1.425,1.425,0,0,0,5.842,5.763V15.71a1.425,1.425,0,0,0,1.421,1.421h7.815A1.425,1.425,0,0,0,16.5,15.71V5.763A1.425,1.425,0,0,0,15.078,4.342Zm0,11.368H7.263V5.763h7.815Z",
    transform: "translate(3.251 2.185)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPink);
export default __webpack_public_path__ + "static/media/copy-pink.110cc85158aab51b1f5d12112dd9d34a.svg";
export { ForwardRef as ReactComponent };